import React from 'react';

const Printer = () => (
  <svg width="22px" height="19px" viewBox="0 0 22 19" version="1.1">
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="buttonIcon_print" fill="#10D492">
        <g>
          <polygon id="Fill-1" points="5 3.65589609 17.7077356 3.65589609 17.7077356 0 5 0" />
          <path d="M0,4 L0,12.1117022 L4.53847701,12.1117022 L4.53847701,18.5665524 L17.2462126,18.5665524 L17.2462126,12.1117022 L21.7846897,12.1117022 L21.7846897,4 L0,4 Z M15.4308218,16.7386043 L6.35386782,16.7386043 L6.35386782,10.3407862 L15.4308218,10.3407862 L15.4308218,16.7386043 Z M19.0616035,8.51283813 C18.3093055,8.51283813 17.7002056,7.89923253 17.7002056,7.14173086 C17.7002056,6.38452166 18.3093055,5.77091607 19.0616035,5.77091607 C19.8139014,5.77091607 20.4230013,6.38452166 20.4230013,7.14173086 C20.4230013,7.89923253 19.8139014,8.51283813 19.0616035,8.51283813 L19.0616035,8.51283813 Z" id="Fill-2" />
        </g>
      </g>
    </g>
  </svg>
);

export default Printer;
